@let name = store.nameSg();
@let loading = store.loadingSg();
@let error = errorSg();

<div class="ds-page-header">
  @if (loading) {
    <div class="ds-page-header__loader">
      <atn-ds-loader type="header" />
    </div>
  } @else if (error) {
    Error {{ error }}
  } @else {
    <div class="ds-page-header__name">
      <!-- CASE 1: name input -->
      @if (name) {
        <h4 class="ds-page-header__name-text">
          {{ name }}
        </h4>
      }
      <!-- CASE 2: projected content via <div name> -->
      <ng-content select="[name]" />

      <div class="ds-page-header__name-breadcrumbs">
        @if (store.presentBreadcrumbsSg()) {
          <atn-ds-page-header-breadcrumbs />
        }
      </div>
    </div>
    <div class="ds-page-header__centered">
      <ng-content select="[centered]"></ng-content>
    </div>
    <div class="ds-page-header__actions-and-selectors">
      <div
        class="ds-page-header__actions"
        #actionsContent
      >
        <ng-content select="[actions]"></ng-content>
      </div>
      <!-- Show divider only in case both actions and selectors are present -->
      @if (actionsContent.children.length && selectorsContent.children.length) {
        <div class="ds-page-header__actions-and-selectors-divider">|</div>
      }
      <div
        class="ds-page-header__selectors"
        #selectorsContent
      >
        <ng-content select="[selectors]"></ng-content>
      </div>
    </div>
  }
</div>
